<template><div><h2 id="vertical-dividers" tabindex="-1" class="d-docsite--header-2">Vertical Dividers <a class="header-anchor d-link d-docsite--link d-link" href="#vertical-dividers" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">Use <code v-pre>d-divide-y{n}</code> to create a divider between an element's child items.</p>
<code-example source-code='&lt;dt-stack class=&quot;d-divide-y d-divide-default d-w100p&quot;&gt;
  &lt;dt-stack direction=&quot;row&quot; align=&quot;center&quot; justify=&quot;center&quot; class=&quot;d-p-200&quot;&gt;1&lt;/dt-stack&gt;
  &lt;dt-stack direction=&quot;row&quot; align=&quot;center&quot; justify=&quot;center&quot; class=&quot;d-p-200&quot;&gt;2&lt;/dt-stack&gt;
  &lt;dt-stack direction=&quot;row&quot; align=&quot;center&quot; justify=&quot;center&quot; class=&quot;d-p-200&quot;&gt;3&lt;/dt-stack&gt;
&lt;/dt-stack&gt;'>
<dt-stack class="d-divide-y d-divide-default d-w100p">
  <dt-stack direction="row" align="center" justify="center" class="d-p-200">1</dt-stack>
  <dt-stack direction="row" align="center" justify="center" class="d-p-200">2</dt-stack>
  <dt-stack direction="row" align="center" justify="center" class="d-p-200">3</dt-stack>
</dt-stack>
</code-example>
<h2 id="horizontal-dividers" tabindex="-1" class="d-docsite--header-2">Horizontal Dividers <a class="header-anchor d-link d-docsite--link d-link" href="#horizontal-dividers" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">Use <code v-pre>d-divide-x{n}</code> to create a divider between an element's child items.</p>
<code-example source-code='&lt;dt-stack direction=&quot;row&quot; class=&quot;d-divide-x d-divide-default d-w100p&quot;&gt;
  &lt;dt-stack direction=&quot;row&quot; align=&quot;center&quot; justify=&quot;center&quot; class=&quot;d-w100p d-p-200&quot;&gt;1&lt;/dt-stack&gt;
  &lt;dt-stack direction=&quot;row&quot; align=&quot;center&quot; justify=&quot;center&quot; class=&quot;d-w100p d-p-200&quot;&gt;2&lt;/dt-stack&gt;
  &lt;dt-stack direction=&quot;row&quot; align=&quot;center&quot; justify=&quot;center&quot; class=&quot;d-w100p d-p-200&quot;&gt;3&lt;/dt-stack&gt;
&lt;/dt-stack&gt;'>
<dt-stack direction="row" class="d-divide-x d-divide-default d-w100p">
  <dt-stack direction="row" align="center" justify="center" class="d-w100p d-p-200">1</dt-stack>
  <dt-stack direction="row" align="center" justify="center" class="d-w100p d-p-200">2</dt-stack>
  <dt-stack direction="row" align="center" justify="center" class="d-w100p d-p-200">3</dt-stack>
</dt-stack>
</code-example>
<h2 id="classes" tabindex="-1" class="d-docsite--header-2">Classes <a class="header-anchor d-link d-docsite--link d-link" href="#classes" aria-hidden="true">#</a></h2>
<new-utility-class-table :classes="divideColors">
  <template #example="{ className }">
    <dt-stack direction="row" class="d-fl-shrink0 d-size-75 d-w-50 d-ta-center" :class="[
        className.startsWith('d-divide-x') ? 'd-divide-x d-fl-col2' : 'd-divide-y d-fd-column',
        className
      ]">
      <dt-stack direction="row" align="center" justify="center">1</dt-stack>
      <dt-stack direction="row" align="center" justify="center">2</dt-stack>
    </dt-stack>
  </template>
</new-utility-class-table>
</div></template>


<script setup>
  import { inject } from 'vue';
  import { extractUtilityClasses } from '@utilities';

  const utilityClassDocs = inject('utilityClassDocs');
  const divideColors = extractUtilityClasses(utilityClassDocs, 'd-divide-');
</script>